import { render, staticRenderFns } from "./SavedSearchList.vue?vue&type=template&id=45be0232&"
import script from "./SavedSearchList.vue?vue&type=script&lang=js&"
export * from "./SavedSearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports